module.exports = __webpack_public_path__ + "assets/img/10-2.2bb45f9c.png";